<template>
    <div class="d-flex">
        <!-- <v-col :class="`mx-0 my-0 ${url?'pr-0':''}`"> -->
            <v-file-input
                :label="requiredCharLabel"
                
                color="success"
                v-model="value" 
                hide-details="auto" 
                underlined 
                dense 
                :rules="rule"
                append-icon="mdi-paperclip"
                prepend-icon=""
                :multiple="multiple"
                :error-messages="errorMessages"
                @click:clear="cleared"
                :accept="accept"
                class="file-input mt-3"
            ></v-file-input>
            <div v-if="exturl" >
                <alternativeButton
                :class="`ml-2 btn primary max-h`"
                :props="openUrlBtn"
                id="show-btn"
            ></alternativeButton>
           
            <alternativeButton
                id="delete-btn"
                :class="`mx-1 btn  max-h ${this.disableDelete ? '':'error'}`"
                :props="deleteBtn"
            ></alternativeButton>
            </div>
            
        <!-- </v-col> -->
        
    </div>

   

</template>
<script>
// import { observable } from 'vue';
export default {
    props: ['valueInput', 'rule', 'label', 'multiple', 'errorMessages', 'url', 'accept', 'disableDelete'],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    computed: {
        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                //console.log(value)
                this.$emit('valueChange', value)
            }
        },
        requiredCharLabel:{
            get: function(){
                if(this.label == "" || this.label == undefined)
                    return "";
                const response = this.label + " *";
                for (let i = 0; i < (this?.rule?.length??[]); i++) {
                    if(this.rule[i]([]) != true){
                        return response;
                    }
                }
                return this.label;
            }
        },
        exturl(){
            return this.url;
        }
    },
    data(){
        return{
            // keyV: observable(0),
            openUrlBtn: {
                text: "",
                icon: "mdi-eye-outline",
				to: "",
				block: false,
                textClass:"white--text",
                color:"primary",
                click: ()=>{this.openUrl(this.url)}
            },
            deleteBtn: {
                text: "",
                icon: "mdi-delete",
                textClass:"white--text",
				to: "",
				block: false,
                disabled: this.disableDelete,
                click: ()=>{this.delete()}
            },
        }
    },
    methods:{
        openUrl(fileUrl){
            window.open(fileUrl)
        },
        delete(){
            
            console.log('ok delete', this.exturl);
            this.$emit('update:url', '');
        },
        cleared(){
            this.$emit('cleared:file','');
        }
    }
    
}
</script>

<style lang="scss" >
//    .finp> .v-input__control>.v-input__slot>.v-input__append-inner>{
//       margin-top: 0px !important;
//    }

    //align icons
    .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner{
        align-self: center !important;
        margin-top:  unset !important;
    }


    .max-h{
        height: 2.4375rem !important;
    }
  
</style>

